package com.sddamico.draftmachine.util

import com.sddamico.draftmachine.data.ExternalProvider
import com.sddamico.draftmachine.data.Sport

/**
 * Identity of one ESPN preview request. This is deliberately not a data class: its default string
 * representation must not expose the captured cookies.
 */
internal class EspnLookupRequest(
  val generation: Int,
  private val leagueId: String,
  private val sport: Sport,
  private val season: Int,
  private val espnS2: String,
  private val espnSwid: String,
) {
  fun matches(
    currentGeneration: Int,
    enabled: Boolean,
    provider: ExternalProvider,
    leagueId: String,
    sport: Sport?,
    season: Int?,
    espnS2: String,
    espnSwid: String,
  ): Boolean =
    generation == currentGeneration && enabled && provider == ExternalProvider.ESPN &&
      this.leagueId == leagueId.trim() && this.sport == sport && this.season == season &&
      this.espnS2 == espnS2.trim() && this.espnSwid == espnSwid.trim()
}
